import { update } from 'lodash';

export const loginApi = {
  login: 'v1/login',
  updatePassword: '/v1/update-password',
  signupContactPerson: '/v1/onboard/partner-contact-info',
  forgetPassword: '/v1/forgot-password'
};

export const globalApi = {
  stateList: 'sa/cscs/state/list',
  cityList: 'sa/cscs/city/list',
  loanType: 'company/all-loan-masters/list',
  masterLoanTypes: 'master/loan-types',
  bandDropApi: 'agreement/bank-filter-dropdown/list',
  bankList: 'bank/list',
  bankBranchList: (branchId) => `agreement/branch/${branchId}`,
  sourceList: 'prospect-source/list',
  internalSaleManagerList: 'internal-sales-manager/list',
  allEmpMasterList: 'company/all-emp-masters/list',
  statusList: (statusId) => `status/${statusId}`,
  masterListType: (type) => `common/master-list/${type}`,
  usersList: 'company/users/list',
  partnerTypes: 'master/partner-types',
  docsTypes: 'master/document-types',
  partnerCompanyTypes: 'master/partner-company-type',
  partnerStatusTypes: 'master/partner-status-type',
  partnerLoanMasters: 'company/parent-loan-masters/list',
  companyLoanMasters: 'company/loan-masters/list',
  parentEmpTypes: 'company/parent-emp-types/list',
  empTypesList: 'company/emp-types/list',
  accessLevelList: 'v1/access-level/configs?companyId=',
  departmentList: 'department-list',
  documentTypes: 'master/document-types',
  createPartner: 'onboard/create-partner'
};

export const prospectApi = {
  prospectAdd: 'prospect/create',
  prospectGridList: 'prospect/list',
  prospectList: 'prospect/list-stage-statuses',
  prospectView: 'prospect/view'
};

export const AccessLevelApi = {
  accessLevel: 'v1/access-level/configs'
};

export const CallCenterApi = {
  callCenterGrid: 'call-center/list',
  loanMasterList: 'company/all-loan-masters/list',
  callCenterView: 'call-center/view',
  employementGrid: 'company/parent-emp-types/list',
  SubemployementGrid: 'company/emp-types/list'
};

export const LeadApi = {
  leadList: 'lead/list',
  leadListStatus: 'leads/list-stage-statuses',
  leadView: 'lead/view',
  leadAddComment: 'lead/addComment',
  createRemainder: 'lead/createReminder',
  statusUpdate: 'status/updateStatus',
  assignStatus: (id) => `status/assignable-status/${id}`,
  offlineApplicationRes: 'offline-v2/get-loan-application-by-id',
  recoEngineApi: 'v1/re-token/',
  branchByBankApi: 'agreement/branch'
};
export const DashboardApi = {
  dashboardCard: 'dashboard',
  hierarchyData: '/dashboard/hierarchy/'
};

export const LoginModuleApi = {
  loginList: 'log_in/list',
  loginApproveProcess: 'log_in/approve-for-process',
  loginUserProfile: 'reco/lead-profile',
  recoRecommendedBank: 'reco/recommended-banks'
};

export const BankOpsApi = {
  bankOpsView: 'bankOps/applicants/view',
  bankOpsList: 'bankOps/applicants/list',
  saveDecisionBankInfo: 'bankOps/applicants/saveDecisionInfo',
  addLoginFile: 'bankOps/create-login-file'
};

export const DisburseOpsApi = {
  disburseList: 'disbursed/list',
  disburseView: 'disbursed/view',
  getDecisionInfo: 'disbursed/getDecisionInfo'
};

export const RejectedApi = {
  rejectedList: 'rejected/list',
  rejectedView: 'rejected/view'
};
export const CustomerApi = {
  customerList: 'customer/list',
  customerView: '/customer/view'
};
export const RevenueApi = {
  revenueList: 'revenue/list',
  addNewFile: 'revenue/add-update-file',
  revenueViewFile: 'revenue/view-file',
  revenuePartnerDetails: 'revenue/list/partner-detail',
  revenueAddComment: 'revenue/add-comment',
  commentLogs: (id) => `revenue/list/comment-logs/${id}`,
  revenueMisMatchDownload: '/revenue/download-mis-match-details'
};

export const PayoutApi = {
  payoutList: 'payout/list',
  addupdatePayout: 'payout/add-update',
  payoutView: 'payout/view',
  payoutAddComment: 'payout/add-comment',
  payoutCommentLogs: (id) => `payout/list/comment-logs/${id}`,
  payoutUpload: 'payout/bulk-upload',
  raiseAdavancePayout: 'payout/advance/create',
  pendingAdvancePayout: 'payout/advance/pending',
  payoutSummary: 'payout/overview',
  payoutNetwork: 'payout/network',
  payoutNetworkDownload: 'payout/network/download',
  payoutNetworkView: (id, type) => `payout/network/view/${id}/${type}`,
  payoutDownload: 'payout/download',
  advancePendingView: '/payout/advance/pending',
  advancePendingStatus: '/payout/advance/status',
  payoutPL: 'payout/transactions',
  payoutProfile: 'payout/profile',
  getPaymentMethod: (id) => `partners/payment-methods/partner/${id}`,
  createPaymentMethod: 'partners/payment-methods/create',
  updatePaymentMethod: 'partners/payment-methods/update',
  paymentTypes: 'partners/payment-methods/payment-types',
  uploadSanctionedLetter: 'payout/upload-sanctioned-letter'
};
export const SalesApi = {
  salesList: 'sales/list',
  salesMatchDownload: 'sales/download-sales-mis-details',
  addRemark: 'sales/add-remark',
  viewRemark: (partnerPayoutId) => `sales/view-remark/${partnerPayoutId}`
};

export const UserApi = {
  UserList: 'user/list',
  deleteUser: 'user/delete',
  addUpdateUser: 'upsert/user',
  viewUser: 'user/view',
  createIncentive: '/incentives/create',
  incentiveList: '/incentives',
  uploadIncentive: '/incentives/upload',
  editIncentive: '/incentives/edit'
};

export const ReceiveApi = {
  receiveList: 'receivable/v1/grid/list',
  receiveRecord: 'receivable/v1/view/record',
  receiveSave: 'receivable/v1/save/record',
  receiveDownloadRecord: 'receivable/v1/download-receivable-reports',
  generateInvoice: '/receivable/v1/generate-invoice',
  invoiceList: '/invoice/list',
  invoicePaidApi: 'invoice/payment',
  invoiceDownload: 'invoice'
};

export const ReportApi = {
  // reportList: 'reports/v1/grid-list/mis-reports'
  reportList: 'reports/grid',
  reportDownload: 'reports/download',
  reportHistoryList: 'download-history/report'
};

export const OnboardingApi = {
  onboardingList: 'onboard/list',
  onboardCreatePartner: 'onboard/create-partner',
  onboardDocUpload: 'onboard/document-upload',
  onboardReview: 'onboard/review',
  onboardDownload: 'onboard/download',
  onboardUpdate: 'onboard/update-partner-status',
  onboardCommissionList: 'onboard/list-commission',
  onboardSetCommission: 'onboard/set-commission',
  hierarchyUserLevel: 'hierarchy/',
  reportingManagerList: '/relationship-managers/',
  reportingManagerList2: 'reporting-manager/list',
  onBoardEmailSend: 'verification/email/send',
  onBoardEmailVerify: 'verification/email/verify',
  onBoardMobileSend: 'verification/sendMobileOtp',
  onBoardMobileVerify: 'verification/verifyMobileOtp',
  onBoardAadharSend: 'verification/aadhaar/generate-otp',
  onBoardAadharVerify: 'verification/aadhaar/verify-otp',
  verifyPan: 'verification/verify-pan',
  verifyGst: 'verification/gst/verify',
  sendWelcomeMail: (partnerId) => `onboard/send-welcome-mail/${partnerId}`
};

export const AgreementApi = {
  agreementList: 'agreement/list',
  agreementGroupedList: 'agreement/grouped-list',
  agreementTerminate: 'agreement/terminate',
  agreementView: 'agreement/view',
  agreementEdit: 'agreement/edit',
  saveBankInfo: 'agreement/save-bank-info',
  saveBranchInfo: 'agreement/save-branch-info',
  banktypeList: 'types/by-source/AGGREMENT_BILLING_TYPE',
  documentTypesBySource: 'types/by-source/AGGREMENT_DOCUMENT',
  uploadDocument: 'agreement/uploadDocument',
  updateBilling: 'agreement/update-billing',
  invoiceModeList: 'types/by-source/INVOICE_MODE'
};
export const DataSourceApi = {
  dataSourceList: 'data-source/grid',
  dataSourceView: 'data-source/view',
  dataSourceValidate: 'data-source/validate',
  dataSourceUpload: 'data-source/upload',
  agreementTerminate: 'agreement/terminate',
  agreementEdit: 'agreement/edit',
  saveBankInfo: 'agreement/save-bank-info',
  saveApplyRule: 'data-source/apply-rules',
  agentList: 'department/city/user-list'
};

export const PolicyApi = {
  policyList: 'policy/policies-list',
  addPolicy: 'policy/add-new-policy'
};

export const JourneyApi = {
  JourneyList: 'journey/datagrid',
  TemplateView: 'journey/journey-template/view',
  journeyPublish: 'journey/publish-journey',
  journeyDelete: 'journey/delete-journey',
  journeySave: 'journey/save-journey-as-template',
  templateNameList: 'journey/template-name/list',
  journeyEdit: 'journey/fetch-all-journey-configs',
  TemplateList: 'journey/journey-template/list',
  TemplateCopy: 'journey/journey-template/copy'
};

export const PayableApi = {
  payableList: '/payble/list',
  payableView: '/payble/view',
  // payableDownload: '/payble/download'
  payableDownload: 'payble/download-invoice-pdf',
  payablePayment: 'payble/mark-paid',
  payableConfirmInvoice: 'payble/confirm-invoice'
};

// const getUserListApi = useCallback(() => {
//   const credentials = {
//     companyId: LoginData?.companyId,
//     userId: LoginData?.userId
//   };
//   dispatch(getUsersList(credentials));
// }, [LoginData]);

// useEffect(() => {
//   getUserListApi();
// }, [getUserListApi]);
